/*
 * File: d:\projects\AutoFiFront\src\Content\Home\HomeFilter\ProgressBar\ProgressBar.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday March 3rd 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday March 3rd 2023 10:58:32 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import MobileStepper from '@mui/material/MobileStepper';
import ProgressBarCustom from 'Theme/Component/ProgressBarCustom';

type ProgressBarProps = {
  barColor: string,
  bgColor: string,
  curStep: number,
  step: number
};

export default function ProgressStepper(props: ProgressBarProps) {
  return (
    <ProgressBarCustom barColor={props.barColor} bgColor={props.bgColor} >
      <MobileStepper role="progressbar" aria-label="progessBar"
        variant="progress"
        steps={props.step}
        position="static"
        activeStep={props.curStep}
        sx={{ maxWidth: "100%", flexGrow: 1 }}
        backButton={undefined}
        nextButton={undefined}
        />
    </ProgressBarCustom>
  );
}
